(function(){
    'use strict';

    angular.module('Directives').directive('bbaQuoteBasePostcode', bbaQuoteBasePostcode);
    
    bbaQuoteBasePostcode.$inject = [
        '$timeout',
        'ServiceProfilePostcodeBaseTableService'
    ];

    function bbaQuoteBasePostcode(
        $timeout,
        ServiceProfilePostcodeBaseTableService
    )
    {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/margins/bba-quote-base-postcode.html',
            require: ['^form', '^ngModel'],
            scope: {
                clearTable: '=?',
                isViewMode: '=?',
                ngModel: '=',
                ngOriginalData: '='
            },
            link: bbaQuoteBasePostcodeLink
        }

        function bbaQuoteBasePostcodeLink($scope, element, attr, ngModels){
            $scope.serviceProfilePostcodeBaseTableService = new ServiceProfilePostcodeBaseTableService(
                ngModels[0],
                $scope.ngModel
            );
    
            $scope.addNewMargin = $scope.serviceProfilePostcodeBaseTableService.addNewMargin;
            $scope.postcodeTable = $scope.serviceProfilePostcodeBaseTableService.tableData;

            $scope.$watch('ngModel', (newValue, oldValue) => {
                if(newValue && angular.getObjVal(newValue, 'postcodeFilters.regions')){
                    $scope.postcodeTable = new ServiceProfilePostcodeBaseTableService(
                        ngModels[0],
                        $scope.ngModel
                    );
                    $scope.addNewMargin = $scope.postcodeTable.addNewMargin;
                    $scope.postcodeTable = $scope.postcodeTable.tableData;
                }
            });

            let listener = $scope.$on('postcodeBasedTableUpdate', function(data){
                $timeout(function(){
                    $scope.ngModel.postcodeFiltersRaw = $scope.serviceProfilePostcodeBaseTableService.getPostcodeMarginFormatted();
                    $scope.ngModel.postcodeFiltersFrmOpen = $scope.serviceProfilePostcodeBaseTableService.getOpenForms();
                });
            });

            $scope.$on('$destroy', function(){
                listener();
            });
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/margins/bbaQuoteBasePostcode.js